export default "/app/themes/macleod/public/images/chevron-right.svg?78f4e67e8cac694b00c96d398b0ca737";